import OrgMap from './partial/org-map'
import global from '@/util/mixin/global'
import ScreenMap from '../screen'
import CommonMap from '../../map'

export default {
  mixins:[global],
  data(){
    return {
      type:'car',
      areacode:86,
      companyId:null
    }
  },
  created(){
    this.$watch('$route.meta' , function(nv){
      this.type = nv.type
    },{immediate:true})

    if( this.isCompany ){
      this.companyId = this.subjectId
      if( this.subject && this.subject.districtCode){
        this.areacode = this.subject.districtCode
      }
    }else if( this.isSupervisor ){
      if( this.subject && this.subject.districtCode){
        this.areacode = this.subject.districtCode
      }
    }
  },
  render(){
    if(this.isSupervisor){
      //if( this.type == 'car' ){
       // return <OrgMap><CarStats /></OrgMap>
      //}else{
        return <CommonMap visibleCity={false} defaultAreacode={this.areacode} slient={true} type={this.type} />
     // }
      
    }else{
      return <CommonMap companyId={this.companyId} defaultAreacode={this.areacode} slient={true} type={this.type} />
    }
  }
}